module.exports = __webpack_public_path__ + "static/media/veryvell_3.69ec51cf.png";